import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTemplateImageStyles = makeStyles({
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  templateWithCaption: {
    ...shorthands.gap(tokens.spacingVerticalM),
    ...shorthands.padding(tokens.spacingVerticalXXS, tokens.spacingHorizontalXXS),
  },
  caption: {
    ...shorthands.gap(tokens.spacingVerticalXS),
  },
  imageCard: {
    width: '240px',
    minHeight: '180px',
    height: '200px',
    filter: 'drop-shadow(0px 0.3px 0.9px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1.6px 3.6px rgba(0, 0, 0, 0.13))',
    ...shorthands.padding(tokens.spacingVerticalNone, tokens.spacingHorizontalNone),
    ...shorthands.borderRadius('6px'),
  },
  imageCardThumbnail: {
    objectFit: 'cover',
    ...shorthands.overflow('hidden'),
  },
  darkGrayText: {
    color: '3B3B4F',
  },
  grayText: {
    color: tokens.colorNeutralForeground3,
  },
});

export const useTemplateGridStyles = makeStyles({
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    rowGap: tokens.spacingVerticalM,
    columnGap: tokens.spacingHorizontalM,
    marginTop: tokens.spacingVerticalSNudge,
  },
  skeletonContainer: {
    alignItems: 'center',
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: 'repeat(5, 1fr)',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  filtersRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  filterButton: {
    minWidth: 'auto',
    whiteSpace: 'nowrap',
  },
});
